export function transformToBackendLinkTableUpdate(data: any) { // eslint-disable-line
  return {
    event_id: data.event_id,
    update_type: data.update_type,
    sygno_ids: data.sygno_ids,
    suspicious: data.suspicious,
    alertcase_row_id: data.alertcase_row_id,
    alertcase_id: data.alertcase_id,
  };
}

export function transformFromBackendLinkTableUpdate(backendType: any) { // eslint-disable-line 
  return {...backendType, event_id: backendType.event_id};
}
